export default (urlParameters) => {
  const { dsatUser, dsatUsersArray } = urlParameters;

  jweather.markersByProvider = {
    0: { colorAlias: 'nc-blue' },
    1: { colorAlias: 'yellow' },
    1370: { colorAlias: 'aib-orange' },
    1046: { colorAlias: 'sw-purple' },
    1047: { colorAlias: 'sw-purple' }
  }

  if (dsatUser) {
    let dsatDemoUsers

    jweather.dsat = {};
    jweather.dsat.user = dsatUser;

    dsatDemoUsers = dsatUsersArray.map((user) => {
      delete user.demo

      return user
    })

    if (dsatUser.demo) {
      jweather.dsat.demoUsers = dsatDemoUsers
    }
  }    
}
